(function () {
  const STORAGE_KEY = 'euphoria:wishlist:v1';
  const drawer = document.getElementById('WishlistDrawer');
  if (!drawer) return;

  const itemsRoot = drawer.querySelector('[data-wishlist-items]');
  const emptyState = drawer.querySelector('[data-wishlist-empty]');
  let lastFocusedElement = null;
  let memoryItems = [];
  let storageFailed = false;

  function readItems() {
    if (storageFailed) return [...memoryItems];
    try {
      const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (_error) {
      storageFailed = true;
      return [...memoryItems];
    }
  }

  function writeItems(items) {
    memoryItems = [...items];
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (_error) {
      storageFailed = true;
    }
    render(items);
  }

  function escapeHtml(value) {
    const element = document.createElement('div');
    element.textContent = value || '';
    return element.innerHTML;
  }

  function itemFromButton(button) {
    return {
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle,
      url: button.dataset.productUrl,
      image: button.dataset.productImage,
      price: button.dataset.productPrice,
      variantId: button.dataset.variantId,
      available: button.dataset.productAvailable === 'true'
    };
  }

  function updateButtons(items) {
    const handles = new Set(items.map((item) => item.handle));
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const active = handles.has(button.dataset.productHandle);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
      const label = button.querySelector('[data-wishlist-label]');
      if (label) label.textContent = active ? 'WISH LISTから削除' : 'WISH LISTに追加';
    });
  }

  function render(items) {
    const count = items.length;
    document.querySelectorAll('[data-wishlist-count]').forEach((bubble) => {
      bubble.textContent = count > 99 ? '99+' : String(count);
      bubble.hidden = count === 0;
    });
    document.querySelectorAll('[data-wishlist-heading-count]').forEach((label) => {
      label.textContent = `(${count})`;
    });
    emptyState.classList.toggle('is-visible', count === 0);
    updateButtons(items);

    itemsRoot.innerHTML = items.map((item) => `
      <article class="wishlist-item" data-wishlist-item="${escapeHtml(item.handle)}">
        <a href="${escapeHtml(item.url)}">
          ${item.image ? `<img class="wishlist-item__image" data-wishlist-image-src="${escapeHtml(item.image)}" alt="" loading="lazy" decoding="async">` : ''}
        </a>
        <div>
          <a class="wishlist-item__title" href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a>
          <p class="wishlist-item__price">${escapeHtml(item.price)}</p>
          ${item.available ? `<button type="button" class="wishlist-item__cart" data-wishlist-add-cart data-variant-id="${escapeHtml(item.variantId)}">カートに追加</button>` : '<span>売り切れ</span>'}
        </div>
        <button type="button" class="wishlist-item__remove" data-wishlist-remove="${escapeHtml(item.handle)}" aria-label="${escapeHtml(item.title)}を削除">&times;</button>
      </article>
    `).join('');
    if (drawer.classList.contains('is-open')) loadDrawerImages();
    memoryItems = [...items];
    document.dispatchEvent(new CustomEvent('euphoria:wishlist-change', { detail: { items: [...items] } }));
  }

  function loadDrawerImages() {
    drawer.querySelectorAll('img[data-wishlist-image-src]').forEach(image => {
      image.src = image.dataset.wishlistImageSrc;
      delete image.dataset.wishlistImageSrc;
    });
  }

  function openDrawer(trigger) {
    const headerDrawer = document.querySelector('header-drawer');
    const menuSummary = headerDrawer?.querySelector(':scope > details > summary');
    lastFocusedElement = trigger?.closest('header-drawer') ? menuSummary : (trigger || document.activeElement);
    if (headerDrawer?.querySelector('details[open]')) {
      headerDrawer.closeMenuDrawer(new Event('click'), menuSummary);
    }
    drawer.classList.add('is-open');
    loadDrawerImages();
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('wishlist-open');
    document.querySelectorAll('[data-wishlist-open]').forEach((button) => button.setAttribute('aria-expanded', 'true'));
    drawer.querySelector('[data-wishlist-close]').focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('wishlist-open');
    document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop');
    document.querySelectorAll('[data-wishlist-open]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
    if (lastFocusedElement) lastFocusedElement.focus();
  }

  document.addEventListener('click', async (event) => {
    const openButton = event.target.closest('[data-wishlist-open]');
    if (openButton) return openDrawer(openButton);

    if (event.target.closest('[data-wishlist-close]')) return closeDrawer();

    const toggle = event.target.closest('[data-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      const item = itemFromButton(toggle);
      const items = readItems();
      const index = items.findIndex((storedItem) => storedItem.handle === item.handle);
      if (index >= 0) items.splice(index, 1);
      else items.unshift(item);
      writeItems(items);
      if (index < 0) openDrawer(toggle);
      return;
    }

    const removeButton = event.target.closest('[data-wishlist-remove]');
    if (removeButton) {
      writeItems(readItems().filter((item) => item.handle !== removeButton.dataset.wishlistRemove));
      return;
    }

    const cartButton = event.target.closest('[data-wishlist-add-cart]');
    if (cartButton) {
      cartButton.disabled = true;
      try {
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(cartButton.dataset.variantId), quantity: 1 }] })
        });
        if (!response.ok) throw new Error('Cart request failed');
        cartButton.textContent = '追加しました ♡';
      } catch (_error) {
        cartButton.textContent = '追加できませんでした';
        cartButton.disabled = false;
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY || event.key === null) render(readItems());
  });

  document.addEventListener('shopify:section:load', () => render(readItems()));
  render(readItems());
})();
